import { NotesComponent } from "../../../components/notes/NotesComponent";
import { useField } from "../../../api/useField";
import { useNoteCategories } from "./useNoteCategories";
import { NoteSessionSelect, CategoryHeader, CategorySelect, TitleSelect, renderSessionView } from "./NoteInputs";
import { ColoredLabelChip } from "../../../components/chips/ColoredLabelChip";
import { useFieldSelectOptions } from "../../../utils/useFieldSelectOptions";

export const CaseManagementNotes = () => {
	const { categoryState, titleState, sessionState, callbacks } = useNoteCategories();
	const { formatedField: sessionsField } = useField("notes", "sessions");
	const statusChoices = useFieldSelectOptions("sessions", "status");

	if (!categoryState.choices.length) return <NotesComponent heightOfHeaders={300} />;

	const categoryConfig = {
		isViewOnly: categoryState.isViewOnly,
		validateBeforeSave: () => {
			if (!titleState.value) return false;
			if (titleState.hasSession && !sessionState.value) return false;
			return true;
		},
		headerComponent: <CategoryHeader categoryState={categoryState} />,
		createCategorySelect: categoryState.isGeral ? undefined : <CategorySelect categoryState={categoryState} />,
		titleSelect: categoryState.isGeral ? undefined : (currentTitle: string | null) => (
			<TitleSelect titleState={titleState} currentTitle={currentTitle} />
		),
		...callbacks,
		sessionSelect: !categoryState.isGeral && titleState.hasSession ? (currentSessionId: number | null, notes: Array<any>) => {
			const value = sessionState.value !== null ? sessionState.value : (currentSessionId ?? "");
			const availableSessions = sessionState.getAvailableSessions(notes, currentSessionId);
			return <NoteSessionSelect value={value} availableSessions={availableSessions} onChange={sessionState.setSession} />;
		} : undefined,
		renderSessionView: renderSessionView(sessionState.filteredSessions, sessionsField, statusChoices),
		renderTitleChip: (item: any) => {
			const titleChoice = titleState.allChoices.find((choice) => choice.value === item?.title);
			if (!titleChoice || !titleChoice.color) return null;
			return <ColoredLabelChip label={titleChoice.text} color={titleChoice.color} />;
		},
		filter: makeNoteCategoryFilter(categoryState),
		onCreate: categoryState.isGeral ? {} : {
			category: categoryState.value,
			title: titleState.value || null,
			sessions: titleState.hasSession ? (sessionState.value || null) : null,
		},
	};

	return <NotesComponent key={categoryState.value} categoryConfig={categoryConfig} heightOfHeaders={300} />;
};

const makeNoteCategoryFilter = (categoryState: ReturnType<typeof useNoteCategories>["categoryState"]) => {
	if (categoryState.isGeral) {
		return { _or: [
			{ category: { _eq: "customer_support" } },
			{ category: { _eq: "client_owner" } },
			{ category: { _null: true } },
		] };
	}
	if (categoryState.value === "customer_support") {
		return { _or: [{ category: { _eq: "customer_support" } }, { category: { _null: true } }] };
	}
	return { category: { _eq: categoryState.value } };
};
